import React from 'react';
import cn from 'classnames';

interface IBaseProps {
	id: string;
	title: string;
	subtitle: string;
	type?: 'warning';
}

interface WithIcon {
	showIcon: true;
	onIconClick?: () => any;
}

interface WithoutIcon {
	showIcon?: false;
	onIconClick?: undefined;
}

type FinalType = IBaseProps & (WithIcon | WithoutIcon)

export default ({
	id,
	title,
	subtitle,
	type,
	showIcon,
	onIconClick,
}: FinalType) => {
	return (
		<div
			className={cn('accordion__banner-item', type)}
			key={`banner-item-${id}`}
		>
			<div className="title">
				{
					showIcon
						? (
							<span
								className="icon icon-left icon-info"
								aria-label="warning icon"
								role="alert"
							/>
						)
						: null
				}
				{title}
			</div>
			{subtitle}
		</div>
	);
};
